/**
 * Environment configuration for the application
 * Centralizes all environment variable access with type safety and validation
 */

// API Configuration
export const API_CONFIG = {
  baseUrl: import.meta.env.VITE_API_URL || 'http://localhost:7006/api/v1',
} as const;

// App Configuration
export const APP_CONFIG = {
  name: import.meta.env.VITE_APP_NAME || 'SudoSys UI',
  version: import.meta.env.VITE_APP_VERSION || '1.0.0',
} as const;

// Server Configuration
export const SERVER_CONFIG = {
  devPort: parseInt(import.meta.env.VITE_DEV_SERVER_PORT || '5173', 10),
  previewPort: parseInt(import.meta.env.VITE_PREVIEW_PORT || '4173', 10),
  host: import.meta.env.VITE_DEV_SERVER_HOST || '0.0.0.0',
} as const;

// Keycloak Configuration
export const KEYCLOAK_CONFIG = {
  url: import.meta.env.VITE_KEYCLOAK_URL || 'https://sso.aryabhata.org',
  realm: import.meta.env.VITE_KEYCLOAK_REALM || 'aryabhata',
  clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID || 'coding-ui',
} as const;

// Monitoring Configuration
export const MONITORING_CONFIG = {
  sentryDsn: import.meta.env.VITE_SENTRY_DSN,
  googleAnalyticsId: import.meta.env.VITE_GOOGLE_ANALYTICS_ID,
  enableAnalytics: import.meta.env.VITE_ENABLE_ANALYTICS === 'true',
  enableErrorTracking: import.meta.env.VITE_ENABLE_ERROR_TRACKING === 'true',
  enablePerformanceMonitoring:
    import.meta.env.VITE_ENABLE_PERFORMANCE_MONITORING === 'true',
} as const;

// Environment Detection
export const isDevelopment = import.meta.env.DEV;
export const isProduction = import.meta.env.PROD;

// Validation function to ensure required environment variables are set
export const validateEnvironment = () => {
  const requiredVars = [
    'VITE_API_URL',
    'VITE_KEYCLOAK_URL',
    'VITE_KEYCLOAK_REALM',
    'VITE_KEYCLOAK_CLIENT_ID',
  ];

  const optionalVars = [
    'VITE_DEV_SERVER_PORT',
    'VITE_PREVIEW_PORT',
    'VITE_DEV_SERVER_HOST',
  ];

  const missingVars = requiredVars.filter(varName => !import.meta.env[varName]);

  const missingOptionalVars = optionalVars.filter(
    varName => !import.meta.env[varName]
  );

  if (missingVars.length > 0) {
    console.warn(
      `Missing required environment variables: ${missingVars.join(', ')}`
    );
    console.warn('Using default values where available.');
  }

  if (missingOptionalVars.length > 0 && isDevelopment) {
    console.info(
      `Using default values for optional environment variables: ${missingOptionalVars.join(', ')}`
    );
  }

  return missingVars.length === 0;
};
